<template>
  <div>
    <v-container fluid class="d-flex justify-center align-center" style="min-height: 90vh">
      <v-card class="rounded-xl elevation-4 pa-6" max-width="800" width="100%">
        <v-card-title class="justify-center pb-4 text-center">
          <span class="text-h6 font-weight-bold">
            Requestor: {{ VisitorName }} {{ "(" + LicensePlate + ")" }} วันที่
            {{ ChangeFormatDate(CreatedDate) }}
          </span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6">
          <v-container>
            <h3 class="font-weight-bold mb-2 text-center" style="color: black; font-size: 20px">
              Pre Register Summary
            </h3>
            <h3 class="font-weight-bold mt-5 text-center" style="color: black; font-size: 20px">
              Site: <span class="font-weight-medium" style="font-size: 16px">{{ ProjectSite }}</span>
            </h3>
            <v-row dense class="pt-6">
              <v-col cols="12" md="6">
                <p style="font-size: 16px">
                  <b style="color: black">Name:</b> {{ VisitorName }}
                </p>
                <p style="font-size: 16px">
                  <b style="color: black">Phone:</b> {{ Phone }}
                </p>
                <p style="font-size: 16px">
                  <b style="color: black">Date/Time In:</b>
                  {{ ChangeFormatDate(StartDate) }}
                </p>
                <p style="font-size: 16px">
                  <b style="color: black">Created Date:</b>
                  {{ ChangeFormatDate(CreatedDate) }}
                </p>
                   <p style="font-size: 16px">
                  <b style="color: black">Contact About :</b>
                  {{ Subject }}
                </p>
              </v-col>
              <v-col cols="12" md="6">
                <p style="font-size: 16px">
                  <b style="color: black">License Plate:</b> {{ LicensePlate }}
                </p>
                <p style="font-size: 16px">
                  <b style="color: black">Vehicle:</b> {{ VehicleType }}
                </p>
                <p style="font-size: 16px">
                  <b style="color: black">Date/Time Out:</b>
                  {{ ChangeFormatDate(EndDate) }}
                </p>
                <p style="font-size: 16px">
                  <b style="color: black">Created By:</b>
                  {{ CreatedBy }}
                </p>
                <p style="font-size: 16px">
                  <b style="color: black">Project Site:</b>
                  {{ ProjectSite }}
                </p>
              </v-col>
            </v-row>
            <v-row dense justify="center">
              <v-col cols="12" md="8" class="d-flex justify-center">
                <v-btn :disabled="ApproveStatus" color="green" width="150" class="mr-4 white--text rounded-lg" large
                  @click="ApprovePreRegister()">
                  Approve
                </v-btn>
                <v-btn color="error" width="150" :disabled="ApproveStatus" class="white--text rounded-lg" large
                  @click="RejectPreRegister()">
                  Reject
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card class="pa-6 d-flex flex-column align-center justify-center" elevation="8" rounded="xl">
        <v-progress-circular indeterminate color="indigo" size="70" width="6"></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium">Loading, please wait...</span>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "ApproveParking",
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      VisitorID: null,
      VisitorName: "",
      LicensePlate: "",
      CreatedDate: "",
      Phone: "",
      StartDate: "",
      EndDate: "",
      VehicleType: "",
      CreatedBy: "",
      ApproveStatus: false,
      UIDNumber: null,
      Subject: "",
      ProjectSite: "",
    };
  },

  async mounted() {
    let self = this;
    let url = window.location.href;
    if (url != "") {
      let url_text = url.split("/");
      self.getDataPreRegisterForApprove(url_text[url_text.length - 1]);
    }
  },

  methods: {
    getDataPreRegisterForApprove(uid) {
      let self = this;
      let temp = {
        invite_uid: uid,
      };
      self.LoadingDialog = true;
      axios
        .post(`${self.url}PreRegister/getDataPreRegisterForApprove`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.VisitorID = response.data.data.visitorID;
            self.VisitorName = response.data.data.visitorName;
            self.LicensePlate = response.data.data.licensePlate;
            self.CreatedDate = response.data.data.createTime;
            self.Phone = response.data.data.phone;
            self.StartDate = response.data.data.startDate;
            self.EndDate = response.data.data.expireDate;
            self.VehicleType = response.data.data.vehicleType;
            self.CreatedBy = response.data.data.createBy;
            self.ApproveStatus = response.data.data.approve;
            self.Subject = response.data.data.subject;
            self.ProjectSite = response.data.data.projectName;
            self.UIDNumber = uid;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ApprovePreRegister() {
      let self = this;
      let temp = {
        visitorID: self.VisitorID,
      };
      Swal.fire({
        text: "ยืนยันการ Approve ใช่หรือไม่ ?",
        showCancelButton: true,
        confirmButtonColor: "green",
        cancelButtonColor: "#d33",
        confirmButtonText: "Approve",
        icon: "warning",
      }).then((result) => {
        if (result.isConfirmed) {
          self.LoadingDialog = true;
          axios
            .post(`${self.url}PreRegister/ApprovePreRegister`, temp)
            .then(function (response) {
              if (response.data.status == 0) {
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.getDataPreRegisterForApprove(self.UIDNumber);
              }
            })
            .catch(function (error) {
              Swal.fire({
                icon: "error",
                title: "Error...",
                width: 900,
                text: error,
              });
            })
            .finally(() => {
              self.LoadingDialog = false;
            });
        }
      });
    },

    RejectPreRegister() {
      let self = this;
      let temp = {
        visitorID: self.VisitorID,
      };
      Swal.fire({
        text: "ยืนยันการ Reject ใช่หรือไม่ ?",
        showCancelButton: true,
        confirmButtonColor: "green",
        cancelButtonColor: "#d33",
        confirmButtonText: "Reject",
        icon: "warning",
      }).then((result) => {
        if (result.isConfirmed) {
          self.LoadingDialog = true;
          axios
            .post(`${self.url}PreRegister/rejectPreRegisterByVisitorID`, temp)
            .then(function (response) {
              if (response.data.status == 0) {
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  showConfirmButton: false,
                  timer: 1500,
                });
              }
            })
            .catch(function (error) {
              Swal.fire({
                icon: "error",
                title: "Error...",
                width: 900,
                text: error,
              });
            })
            .finally(() => {
              self.LoadingDialog = false;
            });
        }
      });
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },
  },
};
</script>
<style scoped></style>